/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadEmployeeDetails(searchFilter) {
  return await api
    .post(`/auth/employee/getallemployee`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export function loadDropdownAPI(metaData, method) {
  if (method === "post") {
    return api
        .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
        .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

const remotes = {
  loadEmployeeDetails,
  loadDropdownAPI
};

export default remotes;
